import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Alert from '@vtex/styleguide/lib/Alert'

import { GLOBAL_TOP_MESSAGE_TYPE_LIST } from '../constants'

const GlobalTopMessage = ({
  type,
  messageId,
  messageExtraContext,
  alertProps,
}) => {
  if (!messageId) {
    return null
  }

  const messageExtraProps = {
    ...(messageExtraContext ? { values: messageExtraContext } : {}),
  }

  return (
    <div className="mb5">
      <Alert type={type} {...alertProps}>
        <FormattedMessage id={messageId} {...messageExtraProps} />
      </Alert>
    </div>
  )
}

GlobalTopMessage.defaultProps = {
  type: 'error',
}

GlobalTopMessage.propTypes = {
  type: PropTypes.oneOf(GLOBAL_TOP_MESSAGE_TYPE_LIST),
  messageId: PropTypes.string,
  messageExtraContext: PropTypes.object,
  alertProps: PropTypes.object,
}

export default GlobalTopMessage
